import React from "react";
import {
  Box,
  Grid,
  CircularProgress,
  IconButton,
} from "@mui/material";
import {
  Dns,
  Map,
  Assignment,
  Assessment,
  LocationPin,
  LocalShipping,
  SignalCellularAlt
} from "@mui/icons-material";
import {
  BIAnalytics,
  DocumentItem,
  CategorySection
} from "./components";
import {VisibleContent} from "../../components";
import {connect} from "react-redux";
import {refreshContracts, setContract} from "../../store/ContractsStore";
import agent from "../../agent/agent";

class Report extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      documents: [],
      isLoading: true,
      contractId: null,
    };
  }

  componentDidMount = async () => { await this.initState(); }
  componentDidUpdate = async (prevProps) => {
    const prevId = prevProps.contract?.available_contracts?.contract_id;
    const currentId = this.props.contract?.available_contracts?.contract_id;
    if (prevId !== currentId) {
      await this.setState({isLoading: true});
      await this.initState();
    }
  }
  initState = async () => {
    const contractId = this.props?.contract?.available_contracts?.contract_id;
    await this.setState({contractId});
    await this.getDocuments();
  }
  getDocuments = async () => {
    await this.setState({isLoading: true});
    const {contractId} = this.state;
    const documents = await agent.get(`/documents?contract_id=${contractId}`).then((res) => res?.data?.data || []).catch(() => []);
    await this.setState({documents, isLoading: false});
  }

  render() {
    const { documents, isLoading } = this.state;

    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        {/* Хэдер */}
        <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <h1 style={{ margin: 0, fontSize: 24, fontWeight: 500, lineHeight: "28px", color: "#111111" }}>Отчеты</h1>
          <IconButton onClick={this.getDocuments} size="small" sx={{ color: "#4F39F6" }}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 3.125 13.5 3.125 13.5M3.125 13.5H6.25M3.125 13.5V17M2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.8438 2.5 17.5 6.5 17.5 6.5M17.5 6.5V3M17.5 6.5H14.375" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </IconButton>
        </Box>

        {/* Контент */}
        <Grid container spacing="20px">
          <Grid size={9}>
            <VisibleContent visible={!isLoading}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                <CategorySection title="Мониторинг доступности" count={2} Icon={SignalCellularAlt}>
                  <Grid container spacing="16px">
                    <Grid size={6}>
                      <DocumentItem type="stationary_info" title="Информация о работе стационарных комплексов" Icon={Dns} documents={documents} />
                    </Grid>
                    <Grid size={6}>
                      <DocumentItem type="mobile_info" title="Информация о работе передвижных и мобильных комплексов" Icon={LocalShipping} documents={documents} />
                    </Grid>
                  </Grid>
                </CategorySection>
                <CategorySection title="Учет и размещение" count={2} Icon={Map}>
                  <Grid container spacing="16px">
                    <Grid size={6}>
                      <DocumentItem type="tsaf_complexes" title="Перечень сведений о Комплексах ТСАФ" Icon={LocationPin} documents={documents} />
                    </Grid>
                    <Grid size={6}>
                      <DocumentItem type="accounting_journal" title="Журнал учета комплексов" Icon={Assignment} documents={documents} />
                    </Grid>
                  </Grid>
                </CategorySection>
                <CategorySection title="Отчёты по запросам" count={1} Icon={Assessment}>
                  <Grid container spacing="16px">
                    <Grid size={6}>
                      <DocumentItem type="request_statistics" title="Отчёт по запросам" Icon={Assessment} documents={documents} />
                    </Grid>
                  </Grid>
                </CategorySection>
              </Box>
            </VisibleContent>
            <VisibleContent visible={isLoading}>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: 320 }}>
                <CircularProgress />
              </Box>
            </VisibleContent>
          </Grid>
          <Grid size={3}>
            <BIAnalytics />
          </Grid>
        </Grid>
      </Box>
    )
  }
}

const mapStateToProps = (state) => ({ contract: state.contracts?.contract || null });
const mapDispatchToProps = { setContract, refreshContracts };

export default connect(mapStateToProps, mapDispatchToProps)(Report)
